<template>
  <div class="home">
    <LoaderComponent v-show="loading" />
    <HeaderView />
    <section
      class="order-page-main-sec invoice-page-main-sec agency-design-grid-right open-invoices-page-sec"
    >
      <div class="desktop-respovsive-main-sec">
        <div class="invoice-history-content">
          <h2 class="text-heading">Invoices</h2>
          <div class="text-1">
            Review and pay your invoices.
          </div>
        </div>

        <div class="editor-dashboard-sec-2">
          <div class="order-list-tabs">
            <div class="order-input-field">
              <div class="date-picker-box">
                <div class="form-row">
                  <div class="col-md-12">
                    <label>Filter by date</label>
                    <div class="input-daterange input-group" id="m_datepicker">
                      <DatePickerComponent
                        :minDate="minDate"
                        :maxDate="maxDate"
                        :options="options"
                        :position="position"
                        :refVal="'datepickerMenu'"
                        :orderDate="filter.order_date"
                        @getSearchData="getSearchData"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="download-icon-list">
                <div @click="downloadFile()" class="top_icons">
                  <i
                    class="fas fa-file-export"
                    v-b-tooltip.hover.top="'Export CSV'"
                  ></i>
                </div>
                <div class="per-page-right-box">
                  <div class="select-item">
                    <select
                      @change="changePagination()"
                      v-model="filter.per_page"
                    >
                      <option>50</option>
                      <option>100</option>
                      <option>200</option>
                      <option>500</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="addon-table">
              <tr>
                <th>Invoice #</th>
                <th>Invoice For</th>
                <th>Issued</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
              <tr v-for="invoice in invoices" :key="invoice.id">
                <td>{{ invoice.invoice_no || "—" }}</td>
                <td>{{ invoice.invoice_for }}</td>
                <td>{{ invoice.issued_at }}</td>
                <td>{{ numberFormat(invoice.amount, "currency") }}</td>
                <td>
                  <span
                    class="invoice-list-status"
                    :class="invoiceStatusClass(invoice)"
                  >{{ invoice.status }}</span>
                </td>
                <td class="action-btns">
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-primary dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      ...
                    </button>
                    <ul class="dropdown-menu" role="menu">
                      <li>
                        <a href="javascript:;" @click="viewInvoice(invoice)">View</a>
                      </li>
                      <li>
                        <a href="javascript:;" @click="downloadInvoice(invoice)"
                          >Download</a
                        >
                      </li>
                      <li v-if="canPayInvoice(invoice)">
                        <a
                          href="javascript:;"
                          class="proceed-text"
                          @click="payInvoice(invoice)"
                          >Pay</a
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </table>
            <p class="article-text" v-if="invoices.length === 0 && !loading">
              You have no invoices.
            </p>
            <div class="total-records-list" v-if="invoices.length > 0">
              <p>Showing {{ rows.length }} of {{ totalRecords }} records</p>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-list">
        <paginate
          :click-handler="getOpenInvoices"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :page-count="filter.last_page"
          :page-range="3"
          :margin-pages="2"
          :container-class="'className'"
          :records="filter.length"
          v-model="filter.page"
          :per-page="filter.per_page"
        >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import DatePickerComponent from "@/components/DatePickerComponent.vue";
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import { numberFormat } from "@/prod.js";
import Paginate from "vuejs-paginate-next";

export default {
  components: {
    HeaderView,
    DatePickerComponent,
    Paginate,
    LoaderComponent,
  },
  mounted() {
    this.getOpenInvoices();
  },
  data() {
    return {
      numberFormat,
      loading: false,
      filter: {
        s: "",
        e: "",
        order_date: "",
        per_page: 50,
        page: 1,
        last_page: 1,
        length: "",
      },
      minDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
      invoices: [],
      totalRecords: 0,
      rows: [],
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false,
      },
      position: "left",
    };
  },
  methods: {
    getSearchData(value) {
      this.filter.order_date = value;
      this.filter.page = 1;
      this.getOpenInvoices();
    },
    async getOpenInvoices() {
      this.loading = true;
      this.filter.s = this.filter.order_date ? this.filter.order_date[0] : "";
      this.filter.e = this.filter.order_date ? this.filter.order_date[1] : "";
      try {
        let res = await this.$store.dispatch(
          "Billing/getOpenInvoicesAction",
          this.filter
        );
        this.invoices = res.data || [];
        this.totalRecords = res.meta.total;
        this.rows = res.data || [];
        this.filter.page = res.meta.current_page;
        this.filter.per_page = res.meta.per_page;
        this.filter.last_page = res.meta.last_page;
        this.filter.length = res.meta.total;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        toast.error("Unable to load open invoices.", { timeout: 3000 });
      }
    },
    changePagination() {
      this.filter.page = 1;
      this.getOpenInvoices();
    },
    isInvoicePaid(invoice) {
      return String(invoice?.status || "").toLowerCase() === "paid";
    },
    canPayInvoice(invoice) {
      const status = String(invoice?.status || "open").toLowerCase();
      return status === "open" || status === "";
    },
    invoiceStatusClass(invoice) {
      const status = String(invoice?.status || "").toLowerCase();
      if (status === "paid") return "is-paid";
      if (status === "processing") return "is-processing";
      if (status === "failed") return "is-failed";
      return "is-open";
    },
    payInvoice(invoice) {
      if (!invoice.payment_token) {
        toast.error("Payment link is unavailable.", { timeout: 3000 });
        return;
      }
      const routeData = this.$router.resolve({
        path: "/invoice-payment",
        query: { data: invoice.payment_token },
      });
      window.open(routeData.href, "_blank");
    },
    viewInvoice(invoice) {
      this.$router.push({
        path: `/invoice-view/${invoice.id}`,
        query: {
          ...this.$route.query,
          data: invoice.payment_token || undefined,
        },
      });
    },
    async downloadInvoice(invoice) {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(
          "Billing/downloadOpenInvoiceAction",
          invoice.id
        );
        if (response && response.type && response.type.indexOf("application/json") !== -1) {
          this.loading = false;
          toast.error("Invoice PDF could not be downloaded.", { timeout: 3000 });
          return;
        }
        let blob = new Blob([response], {
          type: "application/pdf",
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = invoice.filename || ((invoice.invoice_no || ("INV-" + invoice.id)) + ".pdf");
        link.click();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        toast.error("Invoice PDF could not be downloaded.", { timeout: 3000 });
      }
    },
    downloadFile() {
      var jsonObject = this.invoices;
      var array =
        typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;

      var Head = [
        ['"Invoice #"', '"Invoice For"', '"Issued"', '"Amount"', '"Status"'],
      ];

      var row = [];
      for (var i = 0; i < array.length; i++) {
        row.push({
          key1: '"' + (array[i].invoice_no || array[i].id) + '"',
          key2: '"' + array[i].invoice_for + '"',
          key3: '"' + array[i].issued_at + '"',
          key4: '"$' + array[i].amount + '"',
          key5: '"' + array[i].status + '"',
        });
      }

      for (var item = 0; item < row.length; ++item) {
        Head.push([
          row[item].key1,
          row[item].key2,
          row[item].key3,
          row[item].key4,
          row[item].key5,
        ]);
      }

      var csvRows = [];
      for (var cell = 0; cell < Head.length; ++cell) {
        csvRows.push(Head[cell].join(","));
      }

      var csvString = csvRows.join("\n");
      let csvFile = new Blob([csvString], {
        type: "text/csv",
      });
      let downloadLink = document.createElement("a");
      downloadLink.download = "Invoices.csv";
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
  },
};
</script>

<style scoped>
.invoice-list-status {
  display: inline-block;
  min-width: 64px;
  padding: 4px 10px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  color: #fff;
}
.invoice-list-status.is-open {
  background-color: #00b6cb;
}
.invoice-list-status.is-paid {
  background-color: #41b883;
}
.invoice-list-status.is-processing {
  background-color: #d97706;
}
.invoice-list-status.is-failed {
  background-color: #dc2626;
}

.open-invoices-page-sec :deep(table.addon-table tr td.action-btns .btn-group button.btn.btn-primary.dropdown-toggle) {
  background-color: #00b6cb;
  border: none;
  padding: 1px 12px 11px;
  font-size: 20px;
  box-shadow: none;
  min-height: 0;
  line-height: 1;
}

.open-invoices-page-sec :deep(table.addon-table tr td.action-btns .btn-group button.btn.btn-primary.dropdown-toggle::after) {
  display: none;
}

.open-invoices-page-sec :deep(table.addon-table tr td.action-btns .btn-group ul) {
  top: 9px !important;
  padding: 0;
  border: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 1px 3px 9px 0px #afafaf;
}

.open-invoices-page-sec :deep(table.addon-table tr td.action-btns .btn-group ul li) {
  padding: 0;
  border-bottom: 1px solid #f4f4f4;
}

.open-invoices-page-sec :deep(table.addon-table tr td.action-btns .btn-group ul li a) {
  width: 100%;
  height: auto;
  font-size: 14px;
  padding: 5px 11px;
  border-radius: 0;
  background-color: #fff;
  border: none;
  margin: 0;
  color: #000;
  display: block;
  text-align: center;
}

.open-invoices-page-sec :deep(table.addon-table tr td.action-btns .btn-group ul li a.proceed-text) {
  color: #00b6cb;
}

.open-invoices-page-sec :deep(table.addon-table tr td.action-btns .btn-group ul li a:hover) {
  background-color: #f7f7f7;
}
</style>
